<template>
  <div>
    <h1 class="sec-title">公客池规则设置</h1>
    <template v-if="pageLoading">
      <div class="page-loading-group">
        <i class="el-icon-loading"></i>
        <p class="load-text">正在加载中，请稍后...</p>
      </div>
    </template>
    <template v-else>
      <public-rob :info="info" ref="publicRobRef" />
      <public-drop :info="info" ref="publicDropRef" />
     
      <div class="mt20" v-if="showSave">
        <el-button class="save-btn global-btn primary" @click="handleSave">保存</el-button>
      </div>
    </template>
  </div>
</template>
<script>
import PublicRob from './component/rob';
import PublicDrop from './component/drop';
import {getSystemPublicPool, setSystemPublicPool} from '@/api/system';
export default{
  name: 'PublicRule',
  components: {
    PublicRob,
    PublicDrop
  },
  data () {
    return {
      pageLoading: true,
      info: {},
      showSave: false,
    }
  },
  created() {
    this.initPublic();
    this.$EventBus.$off('changePublicSave');
    this.$EventBus.$on('changePublicSave', this.changePublicSave);
  },
  methods: {
    async initPublic (type) {
      this.pageLoading = true;
      try {
        const res = await getSystemPublicPool();
        this.info = res;
      } catch (error) {
        this.$message.error(error.msg || '操作错误，请重试');
      } finally {
        this.pageLoading = false;
        // 是否需要重新加载页面数据
        this.$nextTick(_ => {
          if (type == 'reload') {
            if (this.$refs.publicRobRef) {
              this.$refs.publicRobRef.initial();
            }
            if (this.$refs.publicDropRef) {
              this.$refs.publicDropRef.initial();
            }
          }
        })
      }
    },
    async handleSave () {
      // 抢客数据
      let robData = {};
      if (this.$refs.publicRobRef) {
        const res = await this.$refs.publicRobRef.getResults();
        if (!res.status) return null;
        robData = res.data;
      }
      // 公客池掉落数据
      let dropData = {};
      if (this.$refs.publicDropRef) {
        const drop = await this.$refs.publicDropRef.getResults();
        if (!drop.status) return null;
        dropData = drop.data;
      }
      try {
        await setSystemPublicPool({
          ...robData,
          ...dropData
        });
        this.$message.success('保存成功');
        // 重新请求数据
        this.initPublic('reload');
      } catch (error) {
        console.log(error)
        this.$message.error(error.msg || '操作错误，请重试');
      }
    },
    changePublicSave (isShow, type){
        if(isShow){
            this.showSave = !!isShow;
        }
        else{
            // 还要判断父级是否改变
            if(type === "rob"){
                this.showSave = this.$refs.publicDropRef.data.auto_shift_public_status !== this.info.auto_shift_public_status;
            }
            else if(type === "drop"){
                this.showSave = this.$refs.publicRobRef.public_pick_status !== this.info.public_pick_status;
            }
            else{
                this.showSave = !!isShow;
            }
        }
    }
  },
}
</script>
<style lang="less" scoped>
  .saveTips{
    color: #999999;
    font-size: 12px;
    margin-bottom: 15px;
  }
</style>
